// src/http/paramsApi.js
import { $authHost } from "./index";

const API = String(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

async function getJSON(path) {
    const res = await fetch(`${API}/${path.replace(/^\/+/, "")}`, {
        method: "GET",
        credentials: "include",
        headers: {
            // accept можно не указывать, но пусть будет
            "Accept": "application/json",
        },
    });

    if (!res.ok) {
        // пробуем достать сообщение в формате твоего API
        let msg = `HTTP ${res.status}`;
        try {
            const data = await res.json();
            msg = data?.message || msg;
        } catch (_) {
            // ignore
        }
        throw new Error(msg);
    }

    return res.json();
}

// Bedroom
export const createBedroom = async (bedroom) => {
    const { data } = await $authHost.post("api/bedroom", bedroom);
    return data;
};
export const fetchBedroom = () => getJSON("api/bedroom");

// Floor
export const createFloor = async (floor) => {
    const { data } = await $authHost.post("api/floor", floor);
    return data;
};
export const fetchFloor = () => getJSON("api/floor");

// Area
export const createArea = async (area) => {
    const { data } = await $authHost.post("api/area", area);
    return data;
};
export const fetchArea = () => getJSON("api/area");

// Parking
export const createParking = async (parking) => {
    const { data } = await $authHost.post("api/parking", parking);
    return data;
};
export const fetchParking = () => getJSON("api/parking");

// Room
export const createRoom = async (room) => {
    const { data } = await $authHost.post("api/room", room);
    return data;
};
export const fetchRoom = () => getJSON("api/room");

// Repair
export const createRepair = async (repair) => {
    const { data } = await $authHost.post("api/repair", repair);
    return data;
};
export const fetchRepair = () => getJSON("api/repair");

// Heating
export const createHeating = async (heating) => {
    const { data } = await $authHost.post("api/heating", heating);
    return data;
};
export const fetchHeating = () => getJSON("api/heating");

// Building
export const createBuilding = async (building) => {
    const { data } = await $authHost.post("api/building", building);
    return data;
};
export const fetchBuilding = () => getJSON("api/building");
